<template>
  <div>
    <div>
      <div class="route-loading-progress">
        <v-progress-linear
          :active="routeLoading"
          indeterminate
          height="4"
          background-color="white"
          background-opacity="0.8"
          class="progress-linear-slower"
          color="primary lighten-2"
          style="position: fixed; top: 0; z-index: 9999"
        >
        </v-progress-linear>
      </div>

      <template v-if="!embeddedMode">
        <AppShowBanners
          placement-name="TAKEOVER"
          :show-only-position-number="1"
        />
        <div v-if="$vuetify.breakpoint.mdAndDown" id="jumpMobile" />
        <div class="justify-center" style="width: 100%">
          <AppNavigation />
        </div>
        <div id="scrollButtonBreakpoint" />
        <AppBreadcrumbs />

        <AppShowFeedback ref="showFeedback" class="mt-4" />

        <!--<AppShowMutationFeedback ref="showMutationFeedback" class="mt-4" />-->
      </template>

      <div
        :class="{
          'primary-content': true,
          noncompetitionEvent: $route.name == 'NonCompetitionCalendar'
        }"
      >
        <keep-alive max="10">
          <router-view
            v-if="get($route, 'meta.keepAlive', false)"
            :key="$route.name"
            class="view"
          />
        </keep-alive>
        <router-view
          v-if="get($route, 'meta.keepAlive', false) == false"
          :key="$route.name"
          class="view"
        />
      </div>
    </div>

    <template v-if="!embeddedMode">
      <AppFooter />

      <v-scroll-y-reverse-transition>
        <div v-show="goUpBtn" class="scrollUp" @click="scrollUp">
          <v-icon color="white" large>$iconCaretUp</v-icon>
        </div>
      </v-scroll-y-reverse-transition>
    </template>

    <AppSnackbar ref="appShowSnackbar" />
    <AppConfirm ref="appConfirmDialog" />
  </div>
</template>
<script>
import TranslatedComponentName from "@/utils/translatedComponentName.js";

import { get } from "lodash-es";

import Cookies from "js-cookie";

import AppNavigation from "@/components/AppNavigation.vue";
import AppBreadcrumbs from "@elements/AppBreadcrumbs.vue";
import AppShowFeedback from "@AppShows/AppShowFeedback.vue";
//import AppShowMutationFeedback from "@AppShows/AppShowMutationFeedback.vue";
import FipaListener from "@/utils/listenerUtility";
import AppConfirm from "@elements/AppConfirm.vue";
import AppSnackbar from "@elements/AppSnackbar.vue";
//import AppTermsAndConditions from "@/components/elements/AppTermsAndConditions";
// import AppAlertNotice from "@/components/elements/AppAlertNotice";
import AppFooter from "@/components/Footer.vue";
import AppShowBanners from "@elements/banners/AppShowBanners.vue";

export default {
  name: "App",
  components: {
    AppNavigation,
    AppConfirm,
    AppFooter,
    AppSnackbar,
    AppBreadcrumbs,
    AppShowFeedback,
    AppShowBanners
    //AppShowMutationFeedback
  },
  inject: {
    embeddedMode: {
      default: false
    }
  },
  provide() {
    return {
      appConfirm: (...props) => this.$refs.appConfirmDialog.open(...props),
      snackbar: (...props) => this.$refs.appShowSnackbar.open(...props),
      snackbarClose: () => this.$refs.appShowSnackbar.close(),
      openServerErrorSnackbar: (...props) =>
        this.openServerErrorSnackbar(...props),
      snackbarServerError: (...props) => this.serverReturnedError(...props)
    };
  },
  data() {
    return {
      routeLoading: false,
      goUpBtn: false,
      tokenExpired: false,
      masterDataLoaded: false,
      frontendVersionNumber: null
    };
  },
  watch: {
    $route: [
      {
        immediate: true,
        handler(to) {
          this.routeLoading = false;

          if (to.name) {
            const i18nText = TranslatedComponentName(to.name);
            document.title = `${this.$federation.webTitle} | ${i18nText}`;
            if (this.$refs.showFeedback) {
              //this.$refs.showMutationFeedback.clearManually();
              this.$refs.showFeedback.close();
            }
          }
        }
      },
      function (to, old) {
        // old.name being null is possible if reloaded onto page where tab with its hash history is used
        if (old.name != null && to.name != old.name && this.$gtag)
          this.$gtag.pageview(to);
      }
    ]
  },
  mounted() {
    FipaListener.on("routeIsLoading", () => {
      this.routeLoading = true;
    });
    FipaListener.on("routeHasCompletedLoading", () => {
      this.routeLoading = false;
    });

    this.$root.$snackbarServerError = this.serverReturnedError;
    this.$root.$confirm = this.$refs.appConfirmDialog.open;
    this.$root.$snackbar = this.$refs.appShowSnackbar.open;
    this.$root.$snackbarClose = this.$refs.appShowSnackbar.close;
    this.$root.$openServerErrorSnackbar = this.openServerErrorSnackbar;

    //this.$root.$openMutationFeedback = this.openMutationFeedback;

    if (!this.embeddedMode) {
      if (!this.$auth.isAuthenticated) {
        if (sessionStorage.getItem("sessionExpired") === "true") {
          this.$root.$snackbar("warn", {
            text: this.$t("common:snackbarMessage.loggedOutSessionExpiration"),
            timeout: -1,
            redirection: true
          });
        } else if (sessionStorage.getItem("loggedOut") === "true") {
          this.$root.$snackbar("success", {
            text: this.$t("common:snackbarMessage.loggedOut"),
            timeout: -1,
            redirection: true
          });
        } else if (sessionStorage.getItem("authTokenUrlExpired") === "true") {
          this.$root.$snackbar("warn", {
            text: this.$t(
              "common:snackbarMessage.loginLinkExpired",
              "Unfortunately the login link has expired. To ensure the secure login, please request a new link."
            ),
            timeout: -1,
            redirection: true
          });
        }
      }
    }
    sessionStorage.removeItem("sessionExpired");
    sessionStorage.removeItem("loggedOut");
    sessionStorage.removeItem("authTokenUrlExpired");

    if (!this.embeddedMode) {
      new IntersectionObserver(entries => {
        this.goUpBtn = entries[0].intersectionRatio <= 0;
      }).observe(this.$el.querySelector("#scrollButtonBreakpoint"));
    }
  },
  updated() {
    // Sometimes hot reload creates whole new components,
    // making old $refs obsolete
    if (this.$refs.showFeedback) {
      this.$root.$showFeedback = {
        open: this.$refs.showFeedback.open,
        close: this.$refs.showFeedback.close,
        showGraphqlError: this.$refs.showFeedback.showGraphqlError
      };
    }

    if (this.$refs.appConfirmDialog) {
      this.$root.$confirm = this.$refs.appConfirmDialog.open;
    }
    if (this.$refs.appShowSnackbar) {
      this.$root.$snackbar = this.$refs.appShowSnackbar.open;
    }
  },
  methods: {
    get,
    openMutationFeedback(feedbackMessages, mutationErrors = []) {
      this.$refs.showMutationFeedback.setManually({
        manualFeedbackMessages: feedbackMessages,
        manualMutationErrors: mutationErrors
      });

      this.$refs.showMutationFeedback.$el.scrollIntoView();
    },
    openServerErrorSnackbar(error) {
      if (error.networkError && (error.networkError.statusCode || 0) < 500) {
        this.$refs.appShowSnackbar.serverError("networkError");
      } else {
        this.$refs.appShowSnackbar.serverError(error);
      }
    },
    serverReturnedError(error) {
      if (
        Cookies.get("enable_tehnical") === true ||
        process.env.NODE_ENV != "production"
      ) {
        // eslint-disable-next-line no-console
        console.error(error);
        //console.info(JSON.parse(JSON.stringify(error)));
      }

      this.openServerErrorSnackbar(error);
    },

    loggingInOut(text) {
      this.loginProcess = true;
      this.loadingText = text;
    },
    scrollUp() {
      window.scrollTo(0, 0);
    }
  }
};
</script>
<style lang="scss" scoped>
.route-loading-progress {
  position: absolute;
  width: 100%;
}

.primary-content {
  min-height: 80vh;
  padding-bottom: 50px;
}

#scrollButtonBreakpoint {
  height: 30px;
  position: absolute;
}

.scrollUp {
  position: fixed;
  background: var(--v-accent-base);
  bottom: 38px;
  right: 45px;
  border-radius: 50%;
  padding: 20px;
  z-index: 5;
  cursor: pointer;
  i {
    font-size: 26px !important;
  }
  @media print {
    display: none !important;
  }
  @media (max-width: 959px) {
    padding: 10px 12px;
    bottom: 25px;
    right: 15px;
    i {
      font-size: 18px !important;
    }
  }
}
</style>
